<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增平台
      </el-button>
      <div class="former">
        <el-input
          v-model="form['PlatformName:like']"
          placeholder="平台名称"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <select2
          v-model="form.client_id"
          url="client"
          labelName="ClientName"
          placeholder="请选择客户"
          no-data-text="无客户"
        ></select2
        >&nbsp;
        <select2
          v-model="form.BusinessTypeID"
          url="basic?type=BusinessType"
          placeholder="请选择业务类型"
          noDataText="无类型"
        ></select2
        >&nbsp;
        <select2
          v-model="form.PlatformLevelID"
          url="basic?type=PlatformLevel"
          placeholder="请选择平台级别"
          noDataText="无级别"
        ></select2
        >&nbsp;
        <el-select
          v-model="is_comm"
          :clearable="true"
          placeholder="是否通讯服务器"
        >
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="PlatformName" label="平台名称">
        <template slot-scope="scope">
          <span v-if="scope.row.DevelopeUnit">{{
            scope.row.DevelopeUnit
          }}</span>
          <!-- <span v-if="scope.row.BusinessType"
            >_{{ scope.row.BusinessType.Name }}</span
          > -->
          <span v-if="scope.row.PlatformName"
            >_{{ scope.row.PlatformName }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="BusinessType.Name"
        label="业务类型"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="PlatformLevel.Name"
        label="平台级别"
        width="80"
      ></el-table-column>
      <el-table-column label="质保/运维状态" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.ProtectStatus" type="success">质保中</el-tag>
          <el-tag v-else type="danger">已过保</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="CommProtocol.Name" label="通讯协议" width="180">
      </el-table-column>
      <el-table-column
        prop="IP"
        label="通讯服务器IP地址"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="Port"
        label="通讯服务器端口号"
        width="140"
      ></el-table-column>
      <el-table-column width="180" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="bindingStation(scope.row)"
            title="绑定站点"
          >
            <i class="fas fa-link"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onSeeItem(scope.row)"
            title="详情"
          >
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <binding
      v-model="item"
      :visible.sync="bindingVisible"
      @form:saved="getItemList"
    />
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./index--form.vue";
import Binding from "./binding.vue";

export default {
  components: {
    ItemForm,
    Binding,
  },
  data() {
    return {
      options: [
        {
          value: true,
          label: "是",
        },
        {
          value: false,
          label: "否",
        },
      ],
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        BusinessTypeID: "",
        PlatformLevelID: "",
        "PlatformName:like": "",
      },
      is_comm: "",
      ifprotect: "",
      contractnumber: "",
      item: this.getEmptyItem(),
      itemVisible: false,
      bindingVisible: false,
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("platform", {
          params: {
            // where: this.form,
            where: _.omit(this.form, "client_id"),
            client_id: this.form.client_id,
            with: [
              "BusinessType",
              "PlatformLevel",
              "CommProtocol",
              "Stations",
              "Belong",
            ],
            ...this.pager,
            is_comm: this.is_comm,
            ifprotect: this.ifprotect,
            contractnumber: this.contractnumber,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除此平台吗？", "提示")
        .then(() => this.$axios.delete(`platform/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    getEmptyItem() {
      return {};
    },
    bindingStation(row) {
      this.item = row;
      this.bindingVisible = true;
    },
    onSeeItem(row) {
      this.$router.push({ name: "CpPlatformDetail", params: { ID: row.ID } });
    },
  },
};
</script>
